import { useNavigate, Link } from 'react-router-dom';
import onHandProducts from '../data/onHandProducts';
import { imgSrc } from '../utils/img';
import { useCart } from '../contexts/CartContext';
import '../pages/ProductDetail.css';
import Footer from '../components/Footer';

const OnHand = () => {
  const { addToCart, getQtyInCart } = useCart();
  const navigate = useNavigate();

  const openDetails = (id) => navigate(`/nails/onhand/${id}`);

  return (
    <>
      <div className="product-detail-wrapper">
        <div className="px-4 py-10 max-w-7xl mx-auto">
          <h1 className="text-4xl font-bold text-center mb-2">Nail&apos;d It Now! — Ready to Ship</h1>
          <h2 className="text-center max-w-xl mx-auto mb-10 mt-0 text-gray-600">
            No waiting, no customizing—these press-ons are already made and ready to ship!
            What you see is exactly what you’ll get. One-of-a-kind sets won’t restock once they sell out!
          </h2>

          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-6">
            {onHandProducts.map((p) => {
              // --- Stock math per item ---
              const stockQty = p.inventory?.trackType === 'stock'
                ? Number(p.inventory?.stockQty ?? 0)
                : Infinity;

              const inCart =
                getQtyInCart(p.id) || getQtyInCart(p.slug) || getQtyInCart(p.sku) || 0;

              const remaining = stockQty === Infinity ? Infinity : Math.max(stockQty - inCart, 0);
              const isSoldOut = stockQty !== Infinity && stockQty <= 0;
              return (
                <div
                  key={p.id}
                  role="button"
                  tabIndex={0}
                  onClick={() => openDetails(p.id)}
                  onKeyDown={(e) => (e.key === 'Enter' ? openDetails(p.id) : null)}
                  className="bg-white rounded-2xl shadow hover:shadow-md transition overflow-hidden flex flex-col cursor-pointer"
                >
                  <div className="relative">
                    <img
                      src={imgSrc(p.thumbnail)}
                      alt={`${p.color} • ${p.style}`}
                      className="w-full h-48 object-cover"
                      loading="lazy"
                    />
                    {stockQty !== Infinity && (
                      <span
                        className={`absolute top-2 left-2 text-xs font-semibold px-2 py-1 rounded ${isSoldOut
                            ? 'bg-gray-200 text-gray-700'
                            : remaining === 1
                              ? 'bg-amber-200 text-amber-900'
                              : 'bg-emerald-200 text-emerald-900'
                          }`}
                      >
                        {isSoldOut ? 'Sold Out' : remaining === 1 ? '1 left' : `${remaining} in stock`}
                      </span>
                    )}
                  </div>

                  <div className="p-4 flex-grow flex flex-col">
                    <h2 className="text-lg font-semibold mb-1">
                      {p.color} • {p.style}
                    </h2>
                    <p className="text-sm text-gray-600 mb-2 capitalize">
                      {p.shape} • {p.length} • {p.price}
                    </p>

                    <div className="mt-auto flex gap-2">
                      <button
                        className={`btn-nene flex-1 ${isSoldOut ? 'opacity-50 cursor-not-allowed' : ''}`}
                        aria-disabled={isSoldOut}
                        disabled={isSoldOut}
                        onClick={(e) => {
                          e.stopPropagation();
                          if (isSoldOut) return;
                          const ok = addToCart({ ...p, quantity: 1 });
                          if (ok) navigate('/nails/cart');
                        }}
                      >
                        {isSoldOut ? 'Sold out' : 'Quick Add'}
                      </button>

                      <Link
                        to={`/nails/onhand/${p.id}`}
                        className="btn-nene flex-1 text-center"
                        onClick={(e) => e.stopPropagation()}
                      >
                        Details
                      </Link>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default OnHand;
